import * as i0 from '@angular/core';
import { forwardRef, Directive, HostBinding, Input, HostListener, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { IspuiSwitcher, IspuiSwitcherOption } from '@ispui/switcher/dist/components/index';

class ISPUISwitcherControlValueAccessor {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.onChange = () => undefined;
        this.onTouched = () => undefined;
    }
    handleValueChange(value) {
        this.onChange(value);
        this.onTouched();
    }
    writeValue(value) {
        this.elementRef.nativeElement.value = value;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
}
ISPUISwitcherControlValueAccessor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUISwitcherControlValueAccessor, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
ISPUISwitcherControlValueAccessor.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: ISPUISwitcherControlValueAccessor, selector: "ispui-switcher[formControlName],ispui-switcher[formControl],ispui-switcher[ngModel]", inputs: { disabled: "disabled", multiple: "multiple" }, host: { listeners: { "change": "handleValueChange($event.target.value)" }, properties: { "attr.disabled": "this.disabled", "attr.multiple": "this.multiple" } }, providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ISPUISwitcherControlValueAccessor), multi: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUISwitcherControlValueAccessor, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ispui-switcher[formControlName],ispui-switcher[formControl],ispui-switcher[ngModel]',
                    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ISPUISwitcherControlValueAccessor), multi: true }],
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { disabled: [{
                type: HostBinding,
                args: ['attr.disabled']
            }, {
                type: Input
            }], multiple: [{
                type: HostBinding,
                args: ['attr.multiple']
            }, {
                type: Input
            }], handleValueChange: [{
                type: HostListener,
                args: ['change', ['$event.target.value']]
            }] } });

class ISPUISwitcherValueAccessor {
}
ISPUISwitcherValueAccessor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUISwitcherValueAccessor, deps: [], target: i0.ɵɵFactoryTarget.Directive });
ISPUISwitcherValueAccessor.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: ISPUISwitcherValueAccessor, selector: "ispui-switcher:not([ngControl]):not([formControlName]):not([ngFormControl]):not([ngModel]):not([formControl])", inputs: { value: "value", disabled: "disabled", multiple: "multiple" }, host: { properties: { "value": "this.value", "attr.disabled": "this.disabled", "attr.multiple": "this.multiple" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUISwitcherValueAccessor, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ispui-switcher:not([ngControl]):not([formControlName]):not([ngFormControl]):not([ngModel]):not([formControl])',
                }]
        }], propDecorators: { value: [{
                type: HostBinding,
                args: ['value']
            }, {
                type: Input
            }], disabled: [{
                type: HostBinding,
                args: ['attr.disabled']
            }, {
                type: Input
            }], multiple: [{
                type: HostBinding,
                args: ['attr.multiple']
            }, {
                type: Input
            }] } });
class ISPUISwitcherOptionValueAccessor {
}
ISPUISwitcherOptionValueAccessor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUISwitcherOptionValueAccessor, deps: [], target: i0.ɵɵFactoryTarget.Directive });
ISPUISwitcherOptionValueAccessor.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: ISPUISwitcherOptionValueAccessor, selector: "ispui-switcher-option", inputs: { skey: "skey", disabled: "disabled", selected: "selected", focusable: "focusable" }, host: { properties: { "attr.skey": "this.skey", "attr.disabled": "this.disabled", "attr.selected": "this.selected", "attr.focusable": "this.focusable" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUISwitcherOptionValueAccessor, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ispui-switcher-option',
                }]
        }], propDecorators: { skey: [{
                type: HostBinding,
                args: ['attr.skey']
            }, {
                type: Input
            }], disabled: [{
                type: HostBinding,
                args: ['attr.disabled']
            }, {
                type: Input
            }], selected: [{
                type: HostBinding,
                args: ['attr.selected']
            }, {
                type: Input
            }], focusable: [{
                type: HostBinding,
                args: ['attr.focusable']
            }, {
                type: Input
            }] } });

class ISPUISwitcherModule {
    constructor() {
        if (typeof customElements !== 'undefined') {
            [IspuiSwitcher, IspuiSwitcherOption].forEach((comp) => {
                if (!customElements.get(comp.is)) {
                    customElements.define(comp.is, comp);
                }
            });
        }
    }
}
ISPUISwitcherModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUISwitcherModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ISPUISwitcherModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUISwitcherModule, declarations: [ISPUISwitcherValueAccessor, ISPUISwitcherControlValueAccessor, ISPUISwitcherOptionValueAccessor], exports: [ISPUISwitcherValueAccessor, ISPUISwitcherControlValueAccessor, ISPUISwitcherOptionValueAccessor] });
ISPUISwitcherModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUISwitcherModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUISwitcherModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ISPUISwitcherValueAccessor, ISPUISwitcherControlValueAccessor, ISPUISwitcherOptionValueAccessor],
                    exports: [ISPUISwitcherValueAccessor, ISPUISwitcherControlValueAccessor, ISPUISwitcherOptionValueAccessor],
                }]
        }], ctorParameters: function () { return []; } });

/**
 * Generated bundle index. Do not edit.
 */

export { ISPUISwitcherControlValueAccessor, ISPUISwitcherModule, ISPUISwitcherOptionValueAccessor, ISPUISwitcherValueAccessor };
